<template>
  <a-card>
    <div class="cardBody">
      <a-form>
        <div>
          <base-input :label="`Member Type`">
            <a-select
              id="membertype"
              v-model="formData.memberType"
              show-search
              optionFilterProp="children"
              @change="fetchSubMemberTypes(true)"
            >
              <a-select-option
                v-for="memberType in options.memberTypes"
                :key="memberType.id"
                :value="memberType.id"
              >
                {{ memberType.name }}
              </a-select-option>
            </a-select>
            <div v-if="$v.formData.memberType.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.memberType.required">
                Field is required
              </div>
            </div>
          </base-input>
          <div
            v-if="
              formData.memberType !== null &&
              formData.memberType !== retailInfo.id
            "
          >
            <base-input :label="subMemberTypeLabel">
              <a-select
                id="subMemberType"
                v-model="formData.subMemberType"
                show-search
                optionFilterProp="children"
                @change="fetchChapterTypes(true)"
              >
                <a-select-option
                  v-for="subMemberType in options.subMemberTypes"
                  :key="subMemberType.id"
                  :value="subMemberType.id"
                >
                  {{ subMemberType.name }}
                </a-select-option>
              </a-select>
              <div v-if="$v.formData.subMemberType.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.subMemberType.required">
                  Field is required
                </div>
              </div>
            </base-input>
            <base-input v-if="displayChapterType" :label="chapterTypeLabel">
              <a-select
                id="chapterType"
                v-model="formData.chapterType"
                show-search
                optionFilterProp="children"
              >
                <a-select-option
                  v-for="chapterType in options.chapterTypes"
                  :key="chapterType.id"
                  :value="chapterType.id"
                >
                  {{ chapterType.name }}
                </a-select-option>
              </a-select>
              <div v-if="$v.formData.chapterType.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.chapterType.required">
                  Field is required
                </div>
              </div>
            </base-input>
          <div v-if="formData.memberType === profMemberType">
            <base-input :label="`TIN`">
              <a-input placeholder="TIN" v-model="formData.tinNumber" />
              <div v-if="showTinErrors">
                <div class="text-danger" v-if="tinErrors.alreadyInUse">
                  Tin Number already in used.
                </div>
              </div>
              <div v-if="$v.formData.tinNumber.$dirty" class="text-danger">
                <div
                  class="error"
                  v-if="
                    !$v.formData.tinNumber.minLength ||
                    !$v.formData.tinNumber.maxLength
                  "
                >
                  Must be between 9 and 12 characters long.
                </div>
              </div>
            </base-input>
            <template>
              <b-button
                v-if="!tinValidated"
                size="sm"
                variant="primary"
                @click="verifyTin"
              >
                Verify Tin Number
              </b-button>
            </template>
          </div>
          </div>
        </div>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
import secureStorage from '../../../controllers/secureStorage';
import { required, requiredIf, maxLength, minLength } from 'vuelidate/lib/validators';

export default {
  props: {
    data: {
      type: Object,
    },
    clpSitePageSettings: { type: Object }
  },
  name: 'MembershipDetails',
  data() {
    return {
      retail: '0001',
      professional: '0002',
      corporateRetail: '0003',
      architect: '0001',
      designer: '0004',
      builder: '0002',
      engineer: '0005',
      soleProp: '0001',
      partnerCorp: '0002',
      coop: '0003',
      profMemberType: 2,
      corpoMemberType: 3,
      displayTin: false,
      verifyTinNumberUrl: '/api/v2/clp_members/check_exist',
      showTinErrors: false,
      tinErrors: {
        required: false,
        alreadyInUse: false,
      },
      tinValidated: false,
      formData: {
        memberType: null,
        subMemberType: null,
        chapterType: null,
        tinNumber: null
      },
      subMemberTypeLabel: 'Sub Member Type',
      chapterTypeLabel: 'Chapter Type',
      options: {
        memberTypes: [],
        subMemberTypes: [],
        chapterTypes: [],
      },
    };
  },
  validations() {
    const validation = {
      formData: {
        memberType: { required },
        subMemberType: {
          required: requiredIf(function () {
            return this.formData.memberType !== this.retailInfo?.id;
          }),
        },
        chapterType: {
          required: requiredIf(function () {
            return (
              this.formData.subMemberType === this.architectInfo?.id ||
              this.formData.subMemberType === this.designerInfo?.id ||
              this.formData.subMemberType === this.builderInfo?.id ||
              this.formData.subMemberType === this.engineerInfo?.id
            );
          }),
        },
        tinNumber: {
          minLength: minLength(9),
          maxLength: maxLength(12),
        },
      },
    };
    return validation;
  },
  async created() {
    await this.fetchMemberTypes();
    const data = this.data;
    this.formData.memberType = data.memberTypeId;
    this.formData.subMemberType = data.subMemberTypeId;
    this.formData.chapterType = data.chapterTypeId;
    this.formData.tinNumber = data.tinNumber;
    if (data.memberTypeId !== null) {
      await this.fetchSubMemberTypes();
    }
    if (data.subMemberTypeId !== null) {
      await this.fetchChapterTypes();
    }
  },
  computed: {
    retailInfo() {
      return this.getInfo(this.options.memberTypes, this.retail, false, false, null);
    },
    professionalInfo() {
      return this.getInfo(this.options.memberTypes, this.professional, false, false, null);
    },
    corporateRetailInfo() {
      return this.getInfo(this.options.memberTypes, this.corporateRetail, false, false, null);
    },
    architectInfo() {
      const professionalInfo = true;
      return this.getInfo(this.options.subMemberTypes, this.architect, professionalInfo, false, this.profMemberType);
    },
    builderInfo() {
      const professionalInfo = true;
      return this.getInfo(this.options.subMemberTypes, this.builder, professionalInfo, false, this.profMemberType);
    },
    designerInfo() {
      const professionalInfo = true;
      return this.getInfo(this.options.subMemberTypes, this.designer, professionalInfo, false, this.profMemberType);
    },
    engineerInfo() {
      const professionalInfo = true;
      return this.getInfo(this.options.subMemberTypes, this.engineer, professionalInfo, false, this.profMemberType);
    },
    solePropInfo() {
      const corporateRetailInfo = true;
      return this.getInfo(this.options.subMemberTypes, this.soleProp, false, corporateRetailInfo, this.corpoMemberType);
    },
    coopInfo() {
      const professionalInfo = true;
      return this.getInfo(this.options.subMemberTypes, this.coop, professionalInfo, false, this.corpoMemberType);
    },
    partnerCorpInfo() {
      const professionalInfo = true;
      return this.getInfo(this.options.subMemberTypes, this.partnerCorp, professionalInfo, false, this.corpoMemberType);
    },
    displayChapterType() {
      let result = false;
      if (
        this.formData.memberType !== null &&
        this.formData.memberType !== this.retailInfo?.id
      ) {
        if (
          (this.formData.subMemberType !== null &&
            this.formData.subMemberType === this.architectInfo?.id) ||
          this.formData.subMemberType === this.builderInfo?.id ||
          this.formData.subMemberType === this.designerInfo?.id ||
          this.formData.subMemberType === this.engineerInfo?.id
        ) {
          result = true;
        }
      }
      return result;
    },
  },
  methods: {
    async verifyTin() {
      this.$v.formData.tinNumber.$touch();
      if (!this.$v.formData.tinNumber.$invalid) {
        if (
          this.formData.tinNumber === null ||
          this.formData.tinNumber === ''
        ) {
          this.showTinErrors = true;
          this.tinErrors.required = true;
          return false;
        }
        const {
          id,
          membership_program_id: membershipProgramId,
          account_id: accountId,
        } = this.clpSitePageSettings;
        const endpointVerifyAccount = this.verifyTinNumberUrl;
        const payload = {
          account_id: accountId,
          membership_program_id: membershipProgramId,
          site_page_id: id,
          type: 'CMPTIN',
          value: `${this.formData.tinNumber}`,
        };
        const result = await HTTPRequest.getRequest(
          endpointVerifyAccount,
          payload
        );
        const { is_available: isAvailable } = result.data;
        if (isAvailable) {
          this.showTinErrors = false;
          this.tinErrors.required = false;
          this.tinErrors.alreadyInUse = false;
          this.tinValidated = true;
          this.$emit('tinVerified');

          if(!this.formData.chapter_type_id){
            this.$emit('verifyValue', false);
          }

          return true;
        } else {
          this.tinErrors.required = false;
          this.showTinErrors = true;
          this.tinErrors.alreadyInUse = true;
          this.$emit('verifyValue', true);

          return false;
        }
      }
    },
    getInfo(items, compare, professionalInfo, corporateRetailInfo, memberType) {
      let details = null;

      if(professionalInfo){
        if (items && items.length > 0 && this.professionalInfo !== null) {
          details = items.find((item) => {
            return item.code === compare && item.member_type_id === memberType
          });
        }
      }

      if(corporateRetailInfo){
        if (items && items.length > 0 && this.corporateRetailInfo !== null) {
          details = items.find((item) => {
            return item.code === compare && item.member_type_id === memberType
          });
        }
      }

      if(!professionalInfo && !corporateRetailInfo && !memberType){
        if (items && items.length > 0) {
          details = items.find((item) => {
            return item.code === compare
          });
        }
      }

      return details;
    },
    async fetchMemberTypes() {
      const corpoRetailType = '0003'
      const sitePageId = secureStorage.getItem('clpSitePageSettings').id;
      const membershipProgramid = secureStorage.getItem('membershipProgramId');
      const result = await HTTPRequest.getRequest(
        `/api/v2/member_types?membership_program_id=${membershipProgramid}&site_page_id=${sitePageId}`
      );

      const filteredItems = result.data.map(item => {
        if (item.code === corpoRetailType) {
          return { ...item, name: 'Corporate' };
        }
        return item;
      });

      this.displayTin = true;
      this.options.memberTypes = filteredItems;
      
    },
    async fetchSubMemberTypes(viaUi = false) {
      const sitePageId = secureStorage.getItem('clpSitePageSettings').id;
      const membershipProgramid = secureStorage.getItem('membershipProgramId');
      const memberTypeId = this.formData.memberType;
      const result = await HTTPRequest.getRequest(
        `/api/v2/member_types/${memberTypeId}/sub_member_types?membership_program_id=${membershipProgramid}&site_page_id=${sitePageId}`
      );
      this.options.subMemberTypes = result.data;
      if (memberTypeId === this.corporateRetailInfo?.id) {
        this.subMemberTypeLabel = 'Business Type';
      } else if (memberTypeId === this.professionalInfo?.id) {
        this.subMemberTypeLabel = 'Professional Type';
      }
      
      // to reset upon changing of member type
      this.tinErrors.required = false;
      this.showTinErrors = false;
      this.tinErrors.alreadyInUse = false;
      this.tinValidated = false;

      this.formData.subMemberType = null;
      this.formData.chapterType = null;
      this.formData.tinNumber = null;

      this.$emit('verifyValue', false);

      if (viaUi) {
        this.formData.subMemberType = null;
      }
    },
    async fetchChapterTypes(viaUi = false) {
      const sitePageId = secureStorage.getItem('clpSitePageSettings').id;
      const membershipProgramid = secureStorage.getItem('membershipProgramId');
      const memberTypeId = this.formData.memberType;
      const subMemberTypeId = this.formData.subMemberType;

      console.table({
        sitePageId,
        membershipProgramid,
        memberTypeId,
        subMemberTypeId,
      });
      if (
        subMemberTypeId === this.architectInfo?.id ||
        subMemberTypeId === this.designerInfo?.id ||
        subMemberTypeId === this.builderInfo?.id ||
        subMemberTypeId === this.engineerInfo?.id
      ) {
        console.log('here @ requesting chapter types');
        const result = await HTTPRequest.getRequest(
          `/api/v2/member_types/${memberTypeId}/sub_member_types/${subMemberTypeId}/chapter_types?membership_program_id=${membershipProgramid}&site_page_id=${sitePageId}`
        );
        this.options.chapterTypes = result.data;
        if (this.formData.subMemberType === this.architectInfo?.id) {
          this.chapterTypeLabel = 'UAP/PIA Chapters';
        }
        if (this.formData.subMemberType === this.designerInfo?.id) {
          this.chapterTypeLabel = 'PIID Chapter';
        }
        if (this.formData.subMemberType === this.engineerInfo?.id) {
          this.chapterTypeLabel = 'Engineering Type';
        }
        if (this.formData.subMemberType === this.builderInfo?.id) {
          this.chapterTypeLabel = 'Specific Builder/Contractor';
        }
      }
      if (viaUi) {
        this.formData.chapterType = null;
      }
    }
  },
  watch: {
    'formData.tinNumber'(newVal) {
      if (!newVal) {
        this.$emit('verifyValue', false);
      }else{
        this.$emit('verifyValue', true);
        this.tinErrors.alreadyInUse = false;
        this.showTinErrors = false;
        this.tinErrors.required = false;
        this.tinValidated = false;
      }
    }
  }
};
</script>

<style></style>
